import { getLoginInform } from 'function/login';
import getSFMSRoute from 'routes/sfms';
import getSFSHRoute from 'routes/sfsh';
import { RETURN_YN } from 'types/type';

export default function getRoute() {
  const { haccpYn } = getLoginInform();

  return {
    label: haccpYn === RETURN_YN.Y ? 'SFSH' : 'SFMS',
    labelDisable: true,
    children: (haccpYn === RETURN_YN.Y ? getSFSHRoute : getSFMSRoute)()
  };
}
